import { useState } from 'react'
import { useHistory } from 'react-router'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'

const ProgrammingPageFooter = (props) => {
    const {
        setSlideDirection,
        enable,
        count,
        setCount,
        setChildren,
        backY,
        buttonPlus,
        nextY,
    } = props
    const [popup, setPopup] = useState(false)
    const [popupText, setPopupText] = useState('')
    const history = useHistory()

    const nextPage = () => {
        setSlideDirection(false)
        sessionStorage.setItem('slideDirection', false)

        const allDetails =
            JSON.parse(sessionStorage.getItem('allDetails')) || {}

        const arr = JSON.parse(sessionStorage.getItem('arr')) || []

        const isnotNone = (value) =>
            value !== null &&
            value !== undefined &&
            value !== '' &&
            value !== 'none'

        if (arr.length === 0) {
            setPopup(true)
            setPopupText('Please add atleast one condition/action :)')
            return
        }

        // No condition type picked at all (block.option still unset) - this is
        // what an untouched block looks like, so it isn't "text/object missing".
        const hasConditionSelected = arr.some((id) =>
            isnotNone(allDetails[id]?.option)
        )

        if (!hasConditionSelected) {
            setPopup(true)
            setPopupText('Please add atleast one condition/action :)')
            return
        }

        // Validate only visible blocks
        const isConditionValid = arr.every((id) => {
            const block = allDetails[id]
            if (!block) return false
            if (!isnotNone(block.option)) return false

            switch (block.option) {
                case 'Speech Recognized':
                    return isnotNone(block.speechText) || isnotNone(block.selectedObject)

                case 'Emotion Detected':
                case 'Object Detected':
                    return isnotNone(block.selectedObject)

                case 'USB':
                    return isnotNone(block.usbValue)

                case 'Face Detected':
                    return isnotNone(block.selectedClassId)

                default:
                    return false
            }
        })

        if (!isConditionValid) {
            setPopup(true)
            setPopupText(
                'Enter text or selected object cannot be empty or none'
            )
            return
        }

        // Validate action block
        const isActionValid = arr.every((id) => {
            const block = allDetails[id]
            if (!block) return false

            return (
                isnotNone(block.displayText) ||
                isnotNone(block.image) ||
                (enable?.s1?.pc && isnotNone(block.sliderOption))
            )
        })

        if (!isActionValid) {
            setPopup(true)
            setPopupText('Please add atleast one condition/action :)')
            return
        }

        // Navigation logic
        if (enable.s1.cam && enable.s1.mic) {
            if (enable.s2.face) history.push('/FaceRecognition')
            else if (enable.s2.emotion) history.push('/EmotionDetection')
            else if (enable.s2.object) history.push('/ObjectDetection')
        } else if (enable.s1.cam) {
            if (enable.s2.face) history.push('/FaceRecognition')
            else if (enable.s2.emotion) history.push('/emotionDetection')
            else if (enable.s2.object) history.push('/objectDetection')
        } else if (enable.s1.mic) {
            history.push('/speechRecognition')
        } else if (enable.s1.pc) {
            history.push('/run')
        }
    }

    const ButtonOnClick = () => {
        const newId = Date.now()

        setCount(count + 1)
        setChildren((arr) => [...arr, newId])
    }

    return (
        <div>
            <img
                src={backY}
                draggable="false"
                alt="back"
                style={{
                    margin: 0,
                    position: 'fixed',
                    top: '92vh',
                    right: '92.7vw',
                    width: '3vw',
                    cursor: 'pointer',
                    transform: 'translate(-50%, -50%)',
                }}
                onClick={() => {
                    setSlideDirection(true)
                    sessionStorage.setItem('slideDirection', true)
                    if (
                        enable.s1.cam === true &&
                        enable.s1.mic === true &&
                        enable.s1.pc === true
                    ) {
                        if (enable.s2.face === true) {
                            history.push('/ImageTrainMachine')
                            // history.push('/savedFaces')
                        } else if (enable.s2.emotion === true) {
                            history.push('/selectDetection')
                        } else if (enable.s2.object === true) {
                            history.push('/selectDetection')
                        }
                    } else if (
                        enable.s1.cam === true &&
                        enable.s1.mic === true
                    ) {
                        if (enable.s2.face === true) {
                            history.push('/ImageTrainMachine')
                            // history.push('/savedFaces')
                        } else if (enable.s2.emotion === true) {
                            history.push('/selectDetection')
                        } else if (enable.s2.object === true) {
                            history.push('/selectDetection')
                        }
                    } else if (
                        enable.s1.cam === true &&
                        enable.s1.pc === true
                    ) {
                        if (enable.s2.face === true) {
                            history.push('/ImageTrainMachine')
                            // history.push('/savedFaces')
                        } else if (enable.s2.emotion === true) {
                            history.push('/selectDetection')
                        } else if (enable.s2.object === true) {
                            history.push('/selectDetection')
                        }
                    } else if (
                        enable.s1.mic === true &&
                        enable.s1.pc === true
                    ) {
                        history.push('/AudioTrainMachine')
                    } else if (enable.s1.cam === true) {
                        if (enable.s2.face === true) {
                            history.push('/ImageTrainMachine')
                            // history.push('/savedFaces')
                        } else if (enable.s2.emotion === true) {
                            history.push('/selectDetection')
                        } else if (enable.s2.object === true) {
                            history.push('/selectDetection')
                        }
                    } else if (enable.s1.mic === true) {
                        history.push('/AudioTrainMachine')
                    } else if (enable.s1.pc === true) {
                        history.push('/chooseDevice')
                    }
                }}
            />
            {/* Element to Move Dynamically */}
            <h2
                style={{
                    position: 'relative',
                    top: '74vh',
                    // font: "Halcyon Regular",
                    fontFamily: 'Halcyon_SemiBold',
                    fontSize: '16px',
                    color: 'grey',
                    textAlign: 'center',
                }}
            >
                Tap + button to keep coding
            </h2>
            <img
                src={buttonPlus}
                draggable="false"
                alt="add"
                style={{
                    margin: 0,
                    position: 'fixed',
                    top: '92vh',
                    left: '50vw',
                    width: '3vw',
                    cursor: 'pointer',
                    transform: 'translate(-50%, -50%)',
                }}
                onClick={() => ButtonOnClick()}
            />
            <img
                src={nextY}
                draggable="false"
                alt="next"
                style={{
                    margin: 0,
                    position: 'fixed',
                    marginBottom: 'auto',
                    top: '92vh',
                    left: '95.8vw',
                    width: '3vw',
                    cursor: 'pointer',
                    transform: 'translate(-50%, -50%)',
                }}
                onClick={nextPage}
            />
            {console.log('MMMMMMM888888', popup)}
            <DialogModal
                show={popup}
                text={popupText}
                showCloseBtn={true}
                handleDialogModalClose={() => setPopup(false)}
            />
        </div>
    )
}

export default ProgrammingPageFooter
